import { createSlice } from '@reduxjs/toolkit';

export interface CapitalizationSchedule {
  termSheetsReceived: string;
  commitmentLetterExecuted: string;
  financialClose: string;
}

const initialState: CapitalizationSchedule = {
  termSheetsReceived: '',
  commitmentLetterExecuted: '',
  financialClose: '',
};

export const CapitalizationScheduleSlice = createSlice({
  name: 'capitalizationScheduleSliceInfo',
  initialState,
  reducers: {
    setCapitalizationSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setCapitalizationSchedule } = CapitalizationScheduleSlice.actions;

export default CapitalizationScheduleSlice.reducer;
